<script>
import Layout from '@layouts/main'
import VehicleSearch from '@components/vehicle-search'
export default {
  page: {
    title: 'Free Vehicle History Report Score | AutoCheck.com',
    meta: [
      {
        name: 'description',
        content:
          'AutoCheck Free Vehicle History Report Score! Enter a VIN or license plate to see the free vehicle history report score.',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.autocheck.com/vehiclehistory/free-score',
      },
    ],
  },
  components: { Layout, VehicleSearch },
}
</script>

<template>
  <Layout>
    <div class="row navMarginMobile freeScore" :class="$style.hero">
      <div class="container mt-4">
        <div class="row">
          <div class="col-12">
            <div id="FreeScore-Hero" :class="$style.heroContent">
              <h3 style="font-size: 2rem;">
                Score a great car with AutoCheck
                <span id="tm">®</span>
              </h3>
              <hr style="border-top: 1px solid #FFF;" />
              <div id="FreeScore-H1">
                <h1 style="font-size: 22px;">
                  Get a FREE AutoCheck vehicle history report score - Enter a
                  VIN or PLATE
                </h1>
                <br />
                <div id="FreeScore-H2" style="width: 65%;">
                  <h2
                    style="font-size: 17px; color: #FFF; line-height: 1.5; font-weight: normal;"
                  >
                    AutoCheck vehicle history reports are the
                    <b>only reports</b> that summarize vehicle history records
                    in one easy-to-understand score. The patented AutoCheck
                    Score® exclusive tool allows you to compare multiple
                    vehicles to help decide which is best. Enter a VIN or plate
                    to see the
                    <b>AutoCheck vehicle history report FREE score.</b>
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12">
            <VehicleSearch :show-score="true" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div id="FreeScore-MainSection">
              <div id="FreeScore-LearnMore-About" class="mt-3 mb-3">
                <h3 class="text-center mb-4"
                  >Learn more about the AutoCheck Score</h3
                >
                <div class="row">
                  <div class="col-md-6 col-12">
                    <iframe
                      src="https://www.youtube-nocookie.com/embed/KShGIjD6eww?rel=0?ecver=1&amp;html5=1"
                      frameborder="0"
                      style="display:block"
                    ></iframe>
                  </div>
                  <div class="col-md-6 col-12" style="position: relative;">
                    <img
                      id="balloon"
                      style="position: absolute; right: 0; top: -75px;"
                      class="d-none d-md-block"
                      src="https://www.autocheck.com/communications/87-balloon.png"
                      alt="Free AutoCheck Report Score"
                    />
                    <div id="FreeScore-CanHelpYou">
                      <h3 class="titleBlue" style="margin-right: 55px;"
                        >AutoCheck Score can help you:</h3
                      >
                      <br />
                      <ul style="margin-right: 40px;">
                        <li>Easily research multiple vehicles.</li>
                        <li>
                          See a score range that shows you how a vehicle
                          compares with others in its class.
                        </li>
                        <li>
                          Predict the likelihood the car will be on the road in
                          five years.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <h3 class="text-center mt-4"
                  >Easier decisions with AutoCheck</h3
                >
                <p>
                  Buy a 25-report package to get access to our vehicle history
                  dashboard. Easily visualize vehicles side by side with
                  AutoCheck Score. Explore all reported event records contained
                  in the full vehicle history report. Ownership records, problem
                  checks and more are neatly organized to help you decide.
                </p>
                <div class="row text-center mb-4">
                  <div class="col-md-4 col-12">
                    <router-link to="vehicle-history-reports">
                      <img
                        id="step-1"
                        src="https://www.autocheck.com/communications/1.png"
                        alt="Free AutoCheck VIN Check"
                      />
                    </router-link>
                  </div>
                  <div class="col-md-4 col-12">
                    <a v-scroll-to="'#searchVin'" href="#"
                      ><img
                        id="step-2"
                        src="https://www.autocheck.com/communications/2.png"
                        alt="Free AutoCheck Plate Check"
                      />
                    </a>
                  </div>
                  <div class="col-md-4 col-12">
                    <a v-scroll-to="'#Comparewithourdashboard'" href="#"
                      ><img
                        id="step-3"
                        src="https://www.autocheck.com/communications/3.png"
                        alt="Free AutoCheck Vehicle History Report Score"
                      />
                    </a>
                  </div>
                </div>
                <div id="Comparewithourdashboard">
                  <a name="dashboard"></a>
                  <h3 class="mt-4 mb-3 text-center"
                    >Compare with our AutoCheck dashboard</h3
                  >
                </div>
                <img
                  id="dashboard-image"
                  class="w-100 mb-4"
                  src="https://www.autocheck.com/communications/dashboard.png"
                  alt="AutoCheck Vehicle History Report Free Score"
                />
                <div id="why-autocheck">
                  <h3 class="mt-4 text-center mb-3"
                    >AutoCheck data gives you the power to decide</h3
                  >
                  <p>
                    AutoCheck, a part of Experian, is trusted by auto industry
                    professionals for the quality of our data when they buy and
                    sell cars. We acquire data from multiple sources — many
                    exclusive to AutoCheck — to give you the information you
                    need to make the best decision when buying a car.
                  </p>
                  <img
                    id="testimonial"
                    class="w-80 ml-auto mr-auto mt-4 mb-4 d-block"
                    style="max-width: 100%;"
                    src="https://www.autocheck.com/communications/score_testimonial.png"
                    alt="AutoCheck vs CarFax"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.hero {
  background-color: #edeff1;
  background-image: url('@assets/images/free-score-hero.jpg');
  background-repeat: no-repeat;
  background-position: center 0;

  @media screen and (max-width: 768px) {
    padding-right: 15px;
    padding-left: 15px;
  }
}
.heroContent {
  h1,
  h3,
  p,
  hr {
    color: #fff;
  }
}
</style>
